/* eslint-disable */
export default {
  logging: 'Kirjataan lokiin...',
  logCall: 'Kirjaa puhelu lokiin',
  editLog: 'Muokkaa lokia',
  select: 'Valitse vastaava tallenne',
  OnHold: 'Pidossa',
  Ringing: 'Soitetaan',
  CallConnected: 'Puhelu yhdistetty',
  unknownUser: 'Tuntematon käyttäjä',
  unknownNumber: 'Nimetön',
  unavailable: 'Ei käytettävissä',
  viewDetails: 'Näytä tiedot',
  addEntity: 'Luo uusi',
  addLog: 'Loki',
  text: 'Tekstiviesti',
  call: 'Soita',
  missedCall: 'Vastaamaton',
  inboundCall: 'Saapuva',
  outboundCall: 'Lähtevät',
  answeredBy: 'Vastannut',
} as const;

// @key: @#@"logging"@#@ @source: @#@"Logging..."@#@
// @key: @#@"logCall"@#@ @source: @#@"Log Call"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"select"@#@ @source: @#@"Select a matching record"@#@
// @key: @#@"OnHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"Ringing"@#@ @source: @#@"Ringing"@#@
// @key: @#@"CallConnected"@#@ @source: @#@"Call Connected"@#@
// @key: @#@"unknownUser"@#@ @source: @#@"Unknown User"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"unavailable"@#@ @source: @#@"Unavailable"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"addEntity"@#@ @source: @#@"Create New"@#@
// @key: @#@"addLog"@#@ @source: @#@"Log"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
// @key: @#@"missedCall"@#@ @source: @#@"Missed"@#@
// @key: @#@"inboundCall"@#@ @source: @#@"Inbound"@#@
// @key: @#@"outboundCall"@#@ @source: @#@"Outbound"@#@
// @key: @#@"answeredBy"@#@ @source: @#@"Answered by"@#@
